export default "__VITE_ASSET__C7cnip4P__"